import type { BannerRatio } from '@proptr/creative-templates';

// The surfaces a post can be built for.
//
// Each maps to the canvas its creative renders at, which is the only thing
// downstream cares about — the platform chrome that used to wrap these
// previews is gone, but WHICH surfaces are selected still decides which
// ratios get built and previewed.

export type Placement =
  | 'facebook-feed'
  | 'facebook-story'
  | 'instagram-feed'
  | 'instagram-story';

export const PLACEMENTS: {
  id: Placement;
  channel: 'Facebook' | 'Instagram';
  surface: 'Feed' | 'Story';
  label: string;
  /** Which canvas the creative renders at. */
  ratio: BannerRatio;
}[] = [
  {
    id: 'facebook-feed',
    channel: 'Facebook',
    surface: 'Feed',
    label: 'Facebook feed',
    ratio: '1:1',
  },
  {
    id: 'facebook-story',
    channel: 'Facebook',
    surface: 'Story',
    label: 'Facebook story',
    ratio: '9:16',
  },
  {
    id: 'instagram-feed',
    channel: 'Instagram',
    surface: 'Feed',
    label: 'Instagram feed',
    ratio: '1:1',
  },
  {
    id: 'instagram-story',
    channel: 'Instagram',
    surface: 'Story',
    label: 'Instagram story',
    ratio: '9:16',
  },
];
